export default {
  admin: {
    products: {
      holdingData: {
        deleteDataSingleDate: {
          button: "Eliminar",
          deleteSuccessText: "Datos de tenencia eliminados exitosamente.",
          prompt: {
            delete: "Eliminar",
            text: (ctx) =>
              `Estás a punto de eliminar permanentemente los datos de tenencia para ${ctx.named("date")}. Si estás seguro, haz clic en el botón a continuación para confirmar.`,
            title: "Eliminar datos de tenencia",
          },
        },
        deletePropertyMetadata: {
          deleteSuccessText: "Propiedad eliminada exitosamente.",
          prompt: {
            cancel: "Cancelar",
            delete: "Eliminar",
            deleteForDate: (ctx) => `Para la fecha ${ctx.named("selectedDate")}`,
            deleteGlobally: "Globalmente",
            text: (ctx) =>
              `Estás a punto de eliminar la propiedad "${ctx.named("propertyToDelete")}". ¿Te gustaría eliminarla globalmente o solo para esta fecha?`,
            title: "Eliminar propiedad",
          },
        },
        enrichDataSingleDate: {
          button: "Enriquecer desde CSV",
          enrichSuccessText: "Datos de tenencia enriquecidos exitosamente.",
          emptyCsv: "Nada que importar — el CSV está vacío.",
          noPropertyToEnrich:
            "No se encontró ninguna propiedad definida por el usuario para enriquecer los datos actuales.",
          enrichPrompt: {
            cancel: "Cancelar",
            condition1:
              "El archivo debe incluir una fila de encabezado con al menos: 'Holding name', 'Isin', 'Currency', y una propiedad adicional definida por el usuario.",
            condition2:
              "Cada fila debe tener una combinación única de 'Holding name', 'Isin', y 'Currency'.",
            condition3:
              "Cada combinación de 'Holding name', 'Isin', y 'Currency' para la fecha objetivo debe aparecer exactamente una vez en el CSV.",
            enrich: "Enriquecer",
            text: "Sube un archivo CSV para enriquecer los datos de tenencia. Se deben cumplir las siguientes condiciones:",
            title: "Enriquecer datos de tenencia",
          },
          enrichNewPropertyPrompt: {
            cancel: "Cancelar",
            enrich: "Enriquecer",
            isCategorical: "Categórico",
            isCategoricalTooltip:
              "Las propiedades categóricas permiten agrupar y mostrar las tenencias en secciones como 'Resumen' y 'Factsheet', ya sea en una fecha específica o a lo largo del tiempo. Estas propiedades se pueden traducir en la sección de Ajuste de datos de tenencia. Si una propiedad categórica se genera automáticamente (no definida por el usuario), también se puede anular en esa sección.",
            isFfill: "Relleno hacia adelante",
            isFfillTooltip:
              "Cuando no hay un valor disponible para una fecha seleccionada, se utilizará el valor precedente más reciente.",
            newProperty: "Nueva propiedad",
            text: "Este enriquecimiento creará nuevas propiedades. Por favor, revisa las propiedades propuestas y define su configuración predeterminada. Nota: incluso las diferencias menores en los nombres de las propiedades (por ejemplo, la distinción entre mayúsculas y minúsculas) resultarán en la creación de nuevas propiedades.",
            title: "Nuevas propiedades detectadas",
          },
          enrichErrorPrompt: {
            close: "Cerrar",
            selectErrorType: "Seleccionar tipo de error:",
            title: "Errores de enriquecimiento",
            columns: {
              currency: "Moneda",
              firstRow: "Primera fila",
              holdingName: "Nombre de tenencia",
              isin: "ISIN",
              rowIndex: "Índice de fila",
            },
            duplicatedHeader: {
              header: "Encabezados duplicados:",
              title: "Encabezado duplicado",
              text: "Su archivo CSV contiene encabezados de columna duplicados. Por favor, renómbrelos para que cada encabezado sea único.",
            },
            emptyHeader: {
              title: "Encabezado vacío",
              text: "Su archivo CSV contiene encabezados de columna vacíos. Por favor, asigne un nombre a cada columna utilizando al menos un carácter no vacío.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Faltan columnas requeridas:",
              title: "Discrepancia de columna",
              text: "Asegúrate de que el encabezado del CSV incluya (distinguiendo entre mayúsculas y minúsculas): Holding name, Isin, Currency.",
            },
            duplicatedConstituent: {
              title: "Constituyente duplicado",
              text: "Elimina las entradas duplicadas para el mismo constituyente.",
            },
            missingConstituent: {
              title: "Constituyente faltante",
              text: "Agrega los constituyentes faltantes para que el CSV cubra completamente la fecha seleccionada.",
            },
            papaparseMissingQuotes: {
              title: "Comillas sin cerrar",
              text: "El análisis del CSV falló porque una cadena entre comillas no se cerró correctamente. Por favor, revisa si faltan comillas de cierre en tus datos.",
            },
            papaparseUndetectableDelimiter: {
              title: "Delimitador indetectable",
              text: "El análisis del CSV falló. No se detectó ningún delimitador común. Asegúrate de que tu archivo utilice consistentemente un solo delimitador, típicamente una coma o un punto y coma.",
            },
            papaparseTooFewFields: {
              title: "Muy pocos campos",
              text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen menos columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
            },
            papaparseTooManyFields: {
              title: "Demasiados campos",
              text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen más columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
            },
          },
        },
        exportDataSingleDate: {
          button: "Exportar como CSV",
        },
        importDataSingleDate: {
          button: "Importar desde CSV",
          emptyCsv: "Nada que importar — el CSV está vacío.",
          importSuccessText: "Datos de tenencia importados exitosamente.",
          importPrompt: {
            cancel: "Cancelar",
            condition1:
              "El archivo debe incluir una fila de encabezado con al menos: 'Holding name', 'Isin', 'Currency', 'value', y 'weight'.",
            condition2:
              "Cada fila debe tener una combinación única de 'Holding name', 'Isin', y 'Currency'.",
            condition3:
              "Cada 'value' y 'weight' debe ser un número en un formato estándar (punto como separador decimal, sin separador de miles).",
            date: "Fecha",
            import: "Importar",
            text: "Sube un CSV para importar datos de tenencia. Se deben cumplir las siguientes condiciones:",
            title: "Importar datos de tenencia",
          },
          importNewPropertyPrompt: {
            cancel: "Cancelar",
            import: "Importar",
            isCategorical: "Categórico",
            isCategoricalTooltip:
              "Las propiedades categóricas permiten agrupar y mostrar las tenencias en secciones como 'Resumen' y 'Factsheet', ya sea en una fecha específica o a lo largo del tiempo. Estas propiedades se pueden traducir en la sección de Ajuste de datos de tenencia. Si una propiedad categórica se genera automáticamente (no definida por el usuario), también se puede anular en esa sección.",
            isFfill: "Relleno hacia adelante",
            isFfillTooltip:
              "Cuando no hay un valor disponible para una fecha seleccionada, se utilizará el valor precedente más reciente.",
            newProperty: "Nueva propiedad",
            text: "Esta importación creará nuevas propiedades. Por favor, revisa las propiedades propuestas y define su configuración predeterminada. Nota: incluso las diferencias menores en los nombres de las propiedades (por ejemplo, la distinción entre mayúsculas y minúsculas) resultarán en la creación de nuevas propiedades.",
            title: "Nuevas propiedades detectadas",
          },
          importErrorsPrompt: {
            close: "Cerrar",
            selectErrorType: "Seleccionar tipo de error:",
            title: "Errores de importación",
            columns: {
              currency: "Moneda",
              firstRow: "Primera fila",
              holdingName: "Nombre de tenencia",
              isin: "ISIN",
              rowIndex: "Índice de fila",
            },
            duplicatedHeader: {
              header: "Encabezados duplicados:",
              title: "Encabezado duplicado",
              text: "Su archivo CSV contiene encabezados de columna duplicados. Por favor, renómbrelos para que cada encabezado sea único.",
            },
            emptyHeader: {
              title: "Encabezado vacío",
              text: "Su archivo CSV contiene encabezados de columna vacíos. Por favor, asigne un nombre a cada columna utilizando al menos un carácter no vacío.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Faltan columnas requeridas:",
              title: "Discrepancia de columna",
              text: "Asegúrate de que el encabezado del CSV incluya (distinguiendo entre mayúsculas y minúsculas): Holding name, Isin, Currency, value, weight.",
            },
            duplicatedConstituent: {
              title: "Constituyente duplicado",
              text: "Elimina las entradas duplicadas para el mismo constituyente.",
            },
            missingValue: {
              title: "Valor faltante",
              text: "A algunas filas les falta un valor. Asegúrate de que cada fila tenga un valor numérico correctamente formateado.",
            },
            invalidValueFormat: {
              title: "Formato de valor inválido",
              text: "No se pudo inferir el formato del valor. Utiliza un punto como separador decimal y sin separador de miles.",
            },
            missingWeight: {
              title: "Peso faltante",
              text: "A algunas filas les falta un peso. Asegúrate de que cada fila tenga un peso numérico correctamente formateado.",
            },
            invalidWeightFormat: {
              title: "Formato de peso inválido",
              text: "No se pudo inferir el formato del peso. Utiliza un punto como separador decimal y sin separador de miles.",
            },
            papaparseMissingQuotes: {
              title: "Comillas sin cerrar",
              text: "El análisis del CSV falló porque una cadena entre comillas no se cerró correctamente. Por favor, revisa si faltan comillas de cierre en tus datos.",
            },
            papaparseUndetectableDelimiter: {
              title: "Delimitador indetectable",
              text: "El análisis del CSV falló. No se detectó ningún delimitador común. Asegúrate de que tu archivo utilice consistentemente un solo delimitador, típicamente una coma o un punto y coma.",
            },
            papaparseTooFewFields: {
              title: "Muy pocos campos",
              text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen menos columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
            },
            papaparseTooManyFields: {
              title: "Demasiados campos",
              text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen más columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
            },
          },
        },
        updatePropertyMetadata: {
          saveSuccessText: "Propiedad actualizada exitosamente.",
          unsavedChangesAlert: "Tienes cambios sin guardar. Si te vas ahora, se descartarán.",
          prompt: {
            isCategorical: "Categórico",
            isCategoricalTooltip:
              "Las propiedades categóricas permiten agrupar y mostrar las tenencias en secciones como 'Resumen' y 'Factsheet', ya sea en una fecha específica o a lo largo del tiempo. Estas propiedades se pueden traducir en la sección de Ajuste de datos de tenencia. Si una propiedad categórica se genera automáticamente (no definida por el usuario), también se puede anular en esa sección.",
            isFfill: "Relleno hacia adelante",
            isFfillTooltip:
              "Cuando no hay un valor disponible para una fecha seleccionada, se utilizará el valor precedente más reciente.",
            propertyForUrl: "Propiedad de URL",
            propertyForUrlTooltip:
              "Especifica el nombre de la propiedad que contiene la URL. El valor de la propiedad actual se utilizará como el texto en el que se puede hacer clic.",
            title: "Actualizar propiedad",
            translation: "Traducción",
          },
        },
      },
    },
  },
  auth: {
    resetPasswordLink: {
      forgotPassword: "¿Olvidaste tu contraseña?",
    },
  },
  cards: {
    needLoginCard: {
      needLogged: "Debes iniciar sesión para ver este contenido.",
    },
  },
  compliance: {
    cookies: {
      buttonText: "Aceptar",
      cookiesUsage:
        "Este sitio web utiliza cookies para mejorar la usabilidad. Al utilizar este sitio web, declaras tu consentimiento para que se utilicen cookies, así como con la política de privacidad, donde puedes encontrar más información sobre las cookies. Enlace: {0}.",
      privacyPolicy: "Política de privacidad",
    },
  },
  components: {
    biggestDrawdownsTable: {
      rank: "Rango",
      startDate: "Fecha de inicio",
      troughDate: "Fecha de mínimo",
      recoveryDate: "Fecha de recuperación",
    },
    stressTestScenariosTable: {
      scenario: "Escenario",
      period: "Período",
      scenarioExtremelyBad: "Extremadamente desfavorable",
      scenarioUnfavourable: "Desfavorable",
      scenarioModerate: "Moderado",
      scenarioFavourable: "Favorable",
    },
    liquidityRiskScenarioTable: {
      timeToLiquidate: "Plazo de liquidación",
      timeBucket1Day: "0-1 día",
      timeBucket2To7Days: "2-7 días",
      timeBucket8To30Days: "8-30 días",
      timeBucket31To90Days: "31-90 días",
      timeBucket91To180Days: "91-180 días",
      timeBucket181To365Days: "181-365 días",
      timeBucketMoreThan365Days: ">365 días",
      waterfallCumulativeWeight: "Cascada peso acumulado",
      proRataCumulativeWeight: "Proporcional peso acumulado",
      nearProportionalCumulativeWeight: "Casi proporcional peso acumulado",
    },
    details: {
      report: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} ${ctx.named("aum") > 1000000 ? "millones" : "millón"}${ctx.named("asOfDate") ? ` (a partir de ${ctx.named("asOfDate")})` : ""}`,
        lastPrice: (ctx) => `${ctx.named("currency")} ${ctx.named("lastPrice")}`,
      },
      overview: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} ${ctx.named("aum") > 1000000 ? "millones" : "millón"} (a partir de ${ctx.named("asOfDate")})`,
        lastPrice: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("lastPrice")} (a partir de ${ctx.named("asOfDate")})`,
      },
    },
    returnsVarGraph: {
      dailyReturn: "Rentabilidad diaria",
      twoWeekReturn: "Rentabilidad 2 semanas",
      monthlyReturn: "Rentabilidad mensual",
      oneDayOnePercent: "VaR 1 día (99%)",
      oneDayFivePercent: "VaR 1 día (95%)",
      twoWeeksOnePercent: "VaR 2 semanas (99%)",
      twoWeeksFivePercent: "VaR 2 semanas (95%)",
      oneMonthOnePercent: "VaR 1 mes (99%)",
      oneMonthFivePercent: "VaR 1 mes (95%)",
    },
    download: {
      tooltip: "Descargar como imagen",
      prompt: {
        downloadPngButton: "Descargar como PNG",
        downloadSvgButton: "Descargar como SVG",
        text: "Elige el formato en el que quieres descargar el componente.",
        title: "Descargar componente",
      },
    },
    portfolioBreakdownOnDate: {
      noDataYet: "Este componente aún no tiene datos.",
    },
    portfolioBreakdownOverTime: {
      noDataYet: "Este componente aún no tiene suficientes datos.",
    },
    statisticsWithPeriods: {
      noStatisticsToDisplay: "No hay estadísticas para mostrar.",
    },
    statistics: {
      noStatisticsToDisplay: "No hay estadísticas para mostrar.",
    },
    operations: {
      statuses: {
        failed: "Fallido",
        pending: "Pendiente",
        running: "En curso",
        succeeded: "Completado",
      },
    },
  },
  datePickers: {
    datePicker: {
      selectDateTooltip: "Seleccionar una fecha",
    },
    dateRangePicker: {
      from: "Desde (aaaa-mm-dd)",
      fullPeriod: "Período completo",
      to: "Hasta (aaaa-mm-dd)",
    },
    zoomPicker: {
      fiveYears: "5A",
      fullPeriod: "MÁX",
      oneMonth: "1M",
      oneYear: "1A",
      sevenYears: "7A",
      sixMonths: "6M",
      threeMonths: "3M",
      tenYears: "10A",
      threeYears: "3A",
      twoYears: "2A",
      ytd: "YTD",
    },
  },
  dropdowns: {
    iconsDropdown: {
      noIcon: "Sin icono",
    },
  },
  editPrompt: {
    copyInAllLangs: "Copiar en todos los idiomas",
    editField: "Editar campo",
    enterText: "Introduce un texto",
    overwriteDataAllShareClasses: "Sobrescribir datos de todas las clases de acciones",
    propertyFilters: {
      title: "Filtros por propiedad",
      tooltip:
        "Para ser tenida en cuenta, una tenencia debe pasar todos los filtros aplicados. Una tenencia pasa un filtro si coincide con alguno de sus valores seleccionados.",
      property: "Propiedad",
      values: "Valores",
      empty: "Todavía no hay filtros por propiedad.",
      add: "Agregar filtro por propiedad",
      multiSelect: {
        placeholder: "Seleccionar valores",
        selectLabel: "Pulsa enter para seleccionar",
        deselectLabel: "Pulsa enter para eliminar",
        selectedLabel: "Seleccionados",
        limitText: (ctx) => `y ${ctx.named("count")} más`,
      },
    },
    id: "ID",
    idTooltip:
      "Este identificador único sirve como referencia para el componente dentro de la plataforma. Cada componente que crees necesita un identificador distinto. Recomendamos la siguiente convención para una mayor legibilidad: usa el título del componente, conviértelo a minúsculas, reemplaza los espacios por un guion. Para un componente titulado 'Mi Tabla Analítica', el identificador sería 'mi-tabla-analitica'.",
    needUniqueId:
      "El identificador proporcionado ya está en uso por otro componente en la ubicación actual o en una vinculada. Por favor, proporciona un identificador distintivo para asegurar la unicidad.",
    numberOfDecimals: "Número de decimales",
    numberOfDecimalsTooltip:
      "El número de decimales para todos los números mostrados en el componente. Ten en cuenta que esto no incluye los ejes de los gráficos.",
    withBenchmark: "Mostrar con el índice de referencia",
    resamplingStrategy: "Estrategia de remuestreo",
    windowHorizon: "Ventana móvil",
    windowHorizonTooltip:
      "La ventana móvil determina el período de 'mirada atrás' utilizado para calcular la volatilidad anualizada en cada punto del gráfico. Un horizonte más corto (por ejemplo, 3 meses) hace que el gráfico sea muy sensible a choques de mercado y cambios repentinos de régimen, aunque puede parecer 'ruidoso' debido a fluctuaciones temporales. Por el contrario, un horizonte más largo (por ejemplo, 1 año) proporciona una vista más suave y estable de los riesgos a largo plazo, eliminando el ruido de corto plazo del mercado, aunque reacciona más lentamente a los eventos actuales. Ten en cuenta que elegir un horizonte más largo también conduce a una fecha de inicio más tardía en el gráfico, ya que la cálculo requiere un período histórico completo antes de que se pueda representar el primer valor.",
    windowHorizonOptions: {
      threeMonths: "3 meses",
      sixMonths: "6 meses",
      oneYear: "1 año",
      twoYears: "2 años",
      threeYears: "3 años",
      fiveYears: "5 años",
      sevenYears: "7 años",
      tenYears: "10 años",
    },
    timeWindow: "Ventana temporal",
    timeWindowOptions: {
      threeMonths: "3 meses",
      sixMonths: "6 meses",
      oneYear: "1 año",
      twoYears: "2 años",
      threeYears: "3 años",
      fourYears: "4 años",
      fiveYears: "5 años",
      sixYears: "6 años",
      sevenYears: "7 años",
      eightYears: "8 años",
      nineYears: "9 años",
      tenYears: "10 años",
      all: "Todo",
    },
    valueAtRisk: "Value at risk",
    valueAtRiskOptions: {
      oneDayOnePercent: "VaR 1 día (99%)",
      oneDayFivePercent: "VaR 1 día (95%)",
      twoWeeksOnePercent: "VaR 2 semanas (99%)",
      twoWeeksFivePercent: "VaR 2 semanas (95%)",
      oneMonthOnePercent: "VaR 1 mes (99%)",
      oneMonthFivePercent: "VaR 1 mes (95%)",
    },
    footnote: "Texto debajo del componente",
    placeholderFootnote:
      "Un texto que aparece debajo del componente. Ej. 'Los honorarios están incluidos.'",
    langTabError: "Algunos campos no son válidos en los siguientes idiomas:",
    settingsOnlyUsedOnOverviewTooltip:
      "Esta configuración afecta exclusivamente a la vista 'Resumen'.",
    startDate: "Fecha de inicio",
    startDateTooltip:
      "Selecciona una fecha de inicio (en formato AAAA-MM-DD) para el componente. El componente se ajustará automáticamente para mostrar los datos a partir de la fecha más temprana disponible para el producto o la fecha que elijas, lo que sea posterior. Dejar este campo en blanco mostrará todos los datos de precios disponibles para el producto.",
    tabError: "Algunos campos no son válidos",
    title: "Título",
    titleEdit: (ctx) => `Editar ${ctx.named("componentId")}`,
    titleAdd: "Añadir componente",
    unsavedChangesAlert: "Tienes cambios sin guardar. Si te vas sin guardar, se perderán.",
    resamplingStrategyOptions: {
      standard: "Estándar",
      standardTooltip:
        "Ajusta automáticamente el nivel de detalle en función del rango de tiempo seleccionado para que el gráfico sea claro y legible.",
      monthly: "Mensual",
      monthlyTooltip: "Muestra el último valore registrado de cada mes en el periodo seleccionado.",
    },
    reportFooter: {
      saveSuccess: "El pie de página se actualizó correctamente.",
      title: "Pie de página",
      text: "Texto",
      showPageNumber: "Mostrar número de página",
      showFooterLine: "Mostrar línea de pie de página",
      margins: {
        bottom: "Inferior",
        left: "Izquierda",
        right: "Derecha",
        title: "Márgenes (mm)",
      },
    },
    reportHeader: {
      backgroundImage: "Imagen de fondo",
      backgroundImageTooltip:
        "Las dimensiones del encabezado son 794 píxeles de ancho y la altura que se elija (véase más abajo), así que usa una imagen con dimensiones que sigan la misma proporción para obtener el mejor resultado.",
      logo: "Logotipo",
      text: "Texto",
      saveSuccess: "El encabezado se actualizó correctamente.",
      showDateRange: "Mostrar rango de fechas",
      textInPrimary: "Texto en color de marca",
      title: "Encabezado",
      useCompanyLogo: "Usar logotipo de la empresa",
      logoPosition: {
        left: "Izquierda",
        right: "Derecha",
        title: "Posición del logotipo",
      },
      datePosition: {
        bottomLeft: "Abajo a la izquierda",
        bottomRight: "Abajo a la derecha",
        centerLeft: "Al centro a la izquierda",
        centerRight: "Al centro a la derecha",
        hidden: "Oculta",
        title: "Posición de la fecha",
        topLeft: "Arriba a la izquierda",
        topRight: "Arriba a la derecha",
      },
      headerVisibility: {
        allPages: "Todas las páginas",
        hidden: "Oculto",
        onlyFirstPage: "Solo en la primera página",
        title: "Visibilidad del encabezado",
      },
      height: {
        title: "Altura",
        large: "Grande (200 px / ~52,90 mm)",
        normal: "Normal (150 px / ~39,67 mm)",
        small: "Pequeña (100 px / ~26,45 mm)",
        veryLarge: "Muy grande (250 px / ~66,12 mm)",
      },
      margins: {
        bottom: "Inferior",
        left: "Izquierda",
        right: "Derecha",
        top: "Superior",
        title: "Márgenes (mm)",
        tooltip: "Los márgenes no afectan a la imagen de fondo.",
      },
      productNamePosition: {
        bottomLeft: "Abajo a la izquierda",
        bottomRight: "Abajo a la derecha",
        centerLeft: "Al centro a la izquierda",
        centerRight: "Al centro a la derecha",
        hidden: "Oculto",
        title: "Posición del nombre del producto",
        topLeft: "Arriba a la izquierda",
        topRight: "Arriba a la derecha",
      },
      textPosition: {
        bottomLeft: "Abajo a la izquierda",
        bottomRight: "Abajo a la derecha",
        centerLeft: "Al centro a la izquierda",
        centerRight: "Al centro a la derecha",
        title: "Posición del texto",
        topLeft: "Arriba a la izquierda",
        topRight: "Arriba a la derecha",
      },
    },
    reportStyle: {
      primaryColor: "Color primario",
      colorSchemePicker: "Selector de esquema de colores",
      colorSchemeTooltip:
        "Este esquema de colores se aplica actualmente a los gráficos de pastel y donut. Si no se proporcionan colores, los gráficos utilizan por defecto el esquema general de la plataforma.",
      saveSuccess: "El estilo se actualizó correctamente.",
      title: "Estilo",
      fontSize: {
        normal: "Normal",
        large: "Grande",
        small: "Pequeño",
        title: "Tamaño de fuente",
      },
      margins: {
        left: "Izquierda",
        right: "Derecha",
        title: "Márgenes (mm)",
      },
      spacing: {
        comfortable: "Cómodo",
        compact: "Compacto",
        title: "Espaciado",
      },
      titleBorder: {
        above: "Encima del título",
        below: "Debajo del título",
        none: "Sin borde",
        title: "Borde del título",
      },
      titlesBold: {
        title: "Títulos de componentes en negrita",
      },
    },
    genericComponent: {
      addColumn: "Añadir columna",
      addRow: "Añadir fila",
      addData: "Añadir datos",
      cantChangeType:
        "No puedes cambiar el tipo de un componente genérico una vez que lo has guardado. Si quieres un tipo diferente, necesitas crear un nuevo componente genérico.",
      columnWithIndex: (ctx) => `Columna ${ctx.named("idx")}`,
      data: "Datos",
      date: "Fecha",
      displayValuesAsPerc: "Mostrar valores como porcentaje",
      displayValuesAsPercTooltip: "Muestra los valores con un símbolo '%' en el gráfico.",
      donutChart: "Gráfico de anillo",
      exampleSector: "Ej., Sectores",
      header: "Encabezado",
      horizontalBarChart: "Gráfico de barras horizontales",
      key: "Clave",
      image: "Imagen",
      lineChart: "Gráfico de línea",
      needData:
        "No puedes guardar un componente genérico sin ningún dato o con datos parciales. Elimínalo, añade datos o completa los datos actuales antes de guardar.",
      pieChart: "Gráfico circular",
      removeData: "Eliminar datos",
      showColumnHeader: "Mostrar encabezado de columna",
      table: "Tabla",
      text: "Texto",
      type: "Tipo",
      value: "Valor",
      verticalBarChart: "Gráfico de barras verticales",
      video: "Vídeo",
      weightPercent: "Peso (en %)",
      lineChartSection: {
        fileMust: "Su archivo debe:",
        selectFile: "Seleccionar archivo",
        uploadCsv: "Cargue un archivo CSV que contenga sus datos de series temporales.",
        conditions: {
          dateFormat: "Usar el formato de fecha <strong>YYYY-MM-DD</strong>.",
          dateIncreaseAndUnique: "Contener fechas estrictamente crecientes y únicas.",
          headerRow:
            "Incluir una fila de encabezado con las columnas <code>date</code> y <code>value</code>.",
          maxPoints:
            "Tener un máximo de <strong>500 filas</strong> y un tamaño de archivo inferior a <strong>1&nbsp;MB</strong>.",
          numberFormat:
            "Utilice un punto (.) como separador decimal y no incluya separadores de miles.",
        },
        errors: {
          exceedSize: {
            title: "Archivo demasiado grande",
            text: "El archivo cargado supera 1&nbsp;MB. Limítelo a un máximo de 500 puntos de datos.",
          },
          invalidData: {
            title: "Datos inválidos detectados",
            text: "Algunas filas contienen valores faltantes o inválidos. Asegúrese de que la columna <code>date</code> use el formato <strong>YYYY-MM-DD</strong> y que la columna <code>value</code> contenga números válidos.",
          },
          invalidDataSequence: {
            title: "Secuencia de fechas inválida",
            text: "Las fechas deben ser estrictamente crecientes y únicas. Corrija su archivo e inténtelo de nuevo.",
          },
          parseFail: {
            title: "Error de análisis",
            text: "No se pudo leer correctamente el archivo CSV. Verifique el formato e inténtelo nuevamente. Si el problema persiste, contacte al equipo de Alquant.",
          },
          tooManyDataPoints: {
            title: "Demasiados puntos de datos",
            text: "Su archivo contiene más de 500 filas. Redúzcalo a 500 o menos antes de cargarlo.",
          },
          unexpectedError: {
            title: "Error inesperado",
            text: "Ocurrió un error inesperado al procesar su archivo. Por favor, contacte al equipo de Alquant para obtener ayuda.",
          },
        },
      },
    },
    contacts: {
      addContact: "Añadir contacto",
      contacts: "Contactos",
      contactsPerRow: "Contactos por fila",
      additionalText: "Texto adicional",
      email: "Correo electrónico",
      exampleEmail: "Ej., jdoe@mail.com",
      exampleName: "Ej., John Doe",
      examplePhone: "Ej., +41 79 123 45 67",
      exampleRole: "Ej., Socio",
      image: "Imagen",
      name: "Nombre",
      phone: "Teléfono",
      removeContact: "Eliminar contacto",
      role: "Rol",
    },
    dialog: {
      copyInAllLangs: {
        title: "Copiar en todos los idiomas",
        text: "Vas a copiar todos los valores del idioma actual a todos los demás idiomas. ¿Estás seguro?",
      },
      saveFieldInAllShareClasses: {
        title: "Sobrescribir",
        text: "Vas a sobrescribir este campo en todas las demás clases de acciones de este producto, no solo en la clase de acciones actual. ¿Estás seguro?",
      },
      saveInAllShareClasses: {
        title: "Sobrescribir",
        text: (ctx) =>
          `Vas a sobrescribir los datos de \"${ctx.named("tabName")}\" de todas las demás clases de acciones de este producto con los datos de \"${ctx.named("tabName")}\" de esta clase de acciones (no solo los últimos cambios que hiciste). ¿Estás seguro?`,
      },
    },
    description: {
      contentTitle: "Descripción",
    },
    disclaimer: {
      contentTitle: "Aviso legal",
      defaultWarning:
        "Actualmente no tienes un aviso legal para este producto. Por lo tanto, se ha utilizado el aviso legal estándar. Si escribes un aviso legal aquí, solo se mostrará para este producto.",
    },
    historicalPricesChart: {
      adjusted: "Usar precios ajustados",
      adjustedTooltip:
        "Generalmente, los precios ajustados significan precios que se ajustan por dividendos, divisiones y otros eventos. El precio no ajustado simplemente se refiere al costo de una acción del producto al final del día.",
      defaultLogScale: "Por defecto en escala logarítmica",
      showLogScaleSwitch: "Mostrar interruptor de escala logarítmica",
      priceIndexedTo100: "Usar precios indexados a 100",
    },
    portfolioBreakdown: {
      cantChangeProperty:
        "No puedes cambiar la propiedad de un componente de tenencia una vez que lo has guardado. Si quieres una propiedad diferente, necesitas crear un nuevo componente de tenencia.",
      chartType: "Tipo de gráfico",
      displayOrder: "Orden de visualización",
      donutChart: "Gráfico de anillo",
      horizontalBarChart: "Gráfico de barras horizontales",
      lagRule: "Regla de desfase de datos",
      lagRuleTooltip:
        "Elija cuánto desea retrasar los datos mostrados en este componente. Por ejemplo, un desfase de dos meses al final del mes significa mostrar los datos más recientes disponibles de hace dos meses. Si hoy es 15 de enero de 2025, los datos mostrados corresponderán al 30 de noviembre de 2024.",
      pieChart: "Gráfico circular",
      property: "Propiedad",
      table: "Tabla",
      verticalBarChart: "Gráfico de barras verticales",
      onlyShowTopThenOthers: {
        title: "Mostrar solo los primeros",
        tooltip:
          "Mostrar solo los X primeros (número elegido) y fusionar el resto en 'Otros'. Deja el campo vacío para mostrarlos todos.",
      },
      categoryIdsInOthers: {
        title: 'Elementos a considerar como "Otros"',
        multiSelect: {
          placeholder: "Seleccionar elementos",
          selectLabel: "Pulsa enter para seleccionar",
          deselectLabel: "Pulsa enter para eliminar",
          selectedLabel: "Seleccionados",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
      sortOptions: {
        alphabeticallyAscending: "Nombre (A → Z)",
        alphabeticallyDescending: "Nombre (Z → A)",
        weightAscending: "Peso (Bajo → Alto)",
        weightDescending: "Peso (Alto → Bajo)",
      },
      lagRuleOptions: {
        noLag: "Sin desfase (datos más recientes)",
        oneMonthEnd: "Datos del cierre del mes anterior",
        twoMonthEnd: "Datos del cierre de hace dos meses",
      },
      normalizeBreakdownWeight: "Normalizar pesos",
      normalizeBreakdownWeightTooltip:
        "Si está activado, los pesos se escalan para sumar el 100 % en todas las categorías en la fecha seleccionada (o en cada fecha de la serie temporal).",
    },
    keyCharacteristics: {
      addKeyCharacteristics: "Añadir características clave",
      exampleDynamicExposure: "Ej., Exposición dinámica",
      exampleWeDynamicallyAdapt: "Ej., Nos adaptamos dinámicamente ...",
      header: "Encabezado",
      icon: "Icono",
      paragraph: "Párrafo",
      removeKeyCharacteristics: "Eliminar característica clave",
    },
    biggestDrawdownsTable: {
      numberOfDrawdowns: "Número de pérdidas máximas",
    },
    stressTestScenariosTable: {
      product: "Producto",
      benchmark: "Benchmark",
      periods: "Períodos",
      addPeriod: "Añadir período",
      deletePeriod: "Eliminar período",
    },
    liquidityAnalysisTable: {
      customizedTable: "Vista previa de la tabla",
      holdingsToIgnore: {
        title: "Posiciones a ignorar",
        holdingsMultiselect: {
          placeholder: "Seleccionar posiciones a ignorar",
          selectLabel: "Pulsa enter para seleccionar",
          deselectLabel: "Pulsa enter para eliminar",
          selectedLabel: "Seleccionados",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignorar tenencias cuyo nombre contenga",
        placeholder: "ej. Efectivo, Otros",
      },
    },
    liquidityRiskScenarioTable: {
      rowsByTimeBucket: "Datos por tiempo hasta liquidar",
      amountPlaceholder: "Importe (Mio)",
      weightPlaceholder: "Peso (%)",
    },
    monthlyReturnsTable: {
      descending: "Ordenar años en orden descendente",
      benchmark: "Índice de referencia",
      product: "Producto",
      return: "Retorno",
      nameReplacements: "Reemplazar nombres por defecto",
      nameReplacementsTooltip:
        "Personaliza los nombres del producto y del índice de referencia en el componente. Déjalo en blanco para usar los nombres existentes por defecto.",
    },
    notify: {
      componentSaveSuccess: (ctx) =>
        `Tu componente '${ctx.named("componentId")}' se actualizó exitosamente.`,
    },
    overviewHeader: {
      backgroundImage: "Imagen de fondo",
      backgroundImageTooltip:
        "Ten en cuenta que la imagen que se está considerando actualmente también se utiliza como la imagen de la tarjeta del producto en la página de inicio. Por consiguiente, cualquier alteración en esta imagen afectará simultáneamente la representación del producto en la página de inicio.",
      hideProductName: "Ocultar nombre del producto",
      text: "Texto",
      textInPrimary: "Texto en color de marca",
      textTooltip:
        "Ten en cuenta que el texto que se está considerando actualmente también se utiliza como el texto de la tarjeta del producto en la página de inicio. Por consiguiente, cualquier alteración en este texto afectará simultáneamente la representación del producto en la página de inicio.",
      saveSuccess: "El encabezado se actualizó correctamente.",
      showDownloadLastFactsheetButton:
        'Mostrar botón "@:components.extras.downloadLastFactsheet.downloadLastFactsheet"',
      showDownloadLastFactsheetButtonTooltip:
        'Para que el botón sea visible para un usuario, un documento debe estar marcado como "@:pages.products.documents.prompt.uploadFile.shouldConsiderLastFactsheet" dentro de la sección "Documentos", y debe estar disponible en el idioma seleccionado por el usuario.',
      showFollowButton: "Mostrar botón de seguir",
      title: "Editar encabezado del resumen",
    },
    overviewStyle: {
      colorSchemePicker: "Selector de esquema de colores",
      colorSchemeTooltip:
        "Este esquema de colores se aplica actualmente a los gráficos de pastel y donut. Si no se proporcionan colores, los gráficos utilizan por defecto el esquema general de la plataforma.",
      saveSuccess: "El estilo se actualizó correctamente.",
      title: "Estilo",
      titlesBold: {
        title: "Títulos de componentes en negrita",
      },
    },
    productDetails: {
      addDetail: "Añadir detalle",
      exampleIsin: "Ej., ISIN",
      exampleLU: "Ej., LU2220388479",
      key: "Clave",
      noteDragAndDrop: "Nota: Arrastra y suelta las filas para reordenar los detalles.",
      removeDetail: "Eliminar detalle",
      showAgio: "Mostrar Agio",
      showAuM: "Mostrar AuM",
      showLastPrice: "Mostrar último precio",
      showIsin: "Mostrar ISIN",
      showTer: "Mostrar TER",
      value: "Valor",
    },
    relativePerformanceChart: {
      footnote: "Nota a pie de página",
      placeholderFootnote:
        "Un texto que aparece debajo del gráfico. Ej. 'Los honorarios están incluidos.'",
    },
    riskProfile: {
      level: "Nivel de riesgo",
    },
    shareClassesTable: {
      bloomberg: "Bloomberg",
      class: "Clase",
      column: "Columna",
      columnsToShow: "Columnas a mostrar",
      showColumn: "Mostrar columna",
      defaultFootnote:
        "Perf. SI: los retornos para períodos desde el inicio de más de un año se anualizan, y no se anualizan si son de menos de un año.",
      footnote: "Nota a pie de página",
      inceptionDate: "Fecha de inicio",
      isin: "ISIN",
      mgmtFee: "Com. gest.",
      minInvestment: "Inv. mín.",
      perfFee: "Com. rend.",
      ter: "TER",
      title: "Editar tabla de clases de acciones",
    },
    statistics: {
      benchmark: "Índice de referencia",
      product: "Producto",
      nameReplacements: "Reemplazar nombres por defecto",
      nameReplacementsTooltip:
        "Personaliza los nombres del producto y del índice de referencia en el componente. Déjalo en blanco para usar los nombres existentes por defecto. Por ejemplo, usa un término como 'Producto' para abreviar y ahorrar espacio de visualización.",
      fieldsToDisplay: "Campos a mostrar",
      noteDragAndDrop:
        "Nota: Arrastra y suelta las filas para reordenar las estadísticas mostradas.",
      shownStatisticName: "Nombre de la estadística mostrada",
      showStatistic: "Mostrar estadística",
      statisticId: "ID de estadística",
    },
    statisticsWithPeriods: {
      benchmark: "Índice de referencia",
      product: "Producto",
      nameReplacements: "Reemplazar nombres por defecto",
      nameReplacementsTooltip:
        "Personaliza los nombres del producto y del índice de referencia en el componente. Déjalo en blanco para usar los nombres existentes por defecto. Por ejemplo, usa un término como 'Producto' para abreviar y ahorrar espacio de visualización.",
      fieldsToDisplay: "Campos a mostrar",
      noteDragAndDrop:
        "Nota: Arrastra y suelta las filas para reordenar las estadísticas mostradas.",
      periodsTitle: "Períodos a mostrar",
      shownStatisticName: "Nombre de la estadística mostrada",
      showStatistic: "Mostrar estadística",
      statisticId: "ID de estadística",
      periods: {
        1: "1M",
        3: "3M",
        6: "6M",
        ytd: "YTD",
        12: "1A",
        36: "3A",
        60: "5A",
        84: "7A",
        120: "10A",
        max: "MÁX",
      },
    },
    holdingsTable: {
      aggregateHoldings: "Agrupar tenencias",
      aggregateHoldingsTooltip:
        "Agrupa el valor y el peso de las tenencias que comparten el mismo 'Holding name', 'Isin' y 'Currency'. Todas las demás propiedades se toman de la tenencia con el mayor peso en el grupo. Puedes controlar esta agrupación en la sección 'Ajustes de datos de tenencia' → 'Anular' modificando cualquiera de estos tres campos.",
      fieldsToDisplay: "Campos a mostrar",
      lagRule: "Regla de desfase de datos",
      lagRuleTooltip:
        "Elija cuánto desea retrasar los datos mostrados en este componente. Por ejemplo, un desfase de dos meses al final del mes significa mostrar los datos más recientes disponibles de hace dos meses. Si hoy es 15 de enero de 2025, los datos mostrados corresponderán al 30 de noviembre de 2024.",
      showHeader: "Mostrar encabezado",
      showHoldingsCount: "Mostrar « X de Y tenencias » cuando no se muestren todas las tenencias",
      showTotal: "Mostrar total",
      numHoldings: {
        title: "Número de tenencias a mostrar",
        tooltip:
          "Si dejas este campo en blanco, se mostrarán todos los datos disponibles para las tenencias del producto.",
      },
      holdingsToIgnore: {
        title: "Tenencias a ignorar",
        holdingsMultiselect: {
          placeholder: "Seleccionar tenencias a ignorar",
          selectLabel: "Pulsa enter para seleccionar",
          deselectLabel: "Pulsa enter para eliminar",
          selectedLabel: "Seleccionados",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignorar tenencias cuyo nombre contenga",
        placeholder: "ej. Efectivo, Otros",
      },
      propertyFilters: {
        property: "Propiedad",
        multiSelect: {
          placeholder: "Seleccionar valores",
          selectLabel: "Pulsa enter para seleccionar",
          deselectLabel: "Pulsa enter para eliminar",
          selectedLabel: "Seleccionados",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
      lagRuleOptions: {
        noLag: "Sin desfase (datos más recientes)",
        oneMonthEnd: "Datos del cierre del mes anterior",
        twoMonthEnd: "Datos del cierre de hace dos meses",
      },
      displayOrder: "Orden de visualización",
      sortOptions: {
        alphabeticallyAscending: "Nombre de la participación (A → Z)",
        alphabeticallyDescending: "Nombre de la participación (Z → A)",
        weightAscending: "Peso (Bajo → Alto)",
        weightDescending: "Peso (Alto → Bajo)",
      },
      customizeTable: "Personalizar tabla",
      addColumn: "Añadir columna",
      columnWithIndex: (ctx) => `Columna ${ctx.named("idx")}`,
    },
  },
  extras: {
    changeRoles: {
      changeRoles: "Cambiar roles",
      notify: {
        errorText: "No se han actualizado los roles. Razón: ",
        successText: "Los roles de usuario se han actualizado",
      },
    },
    deleteGenericComponent: {
      delete: "Eliminar",
      deleteAllComponents: "Eliminar todos los componentes",
      deleteOnlyThisComponent: "Eliminar solo este componente",
      deleting: "Eliminando ...",
      deleteSuccess: "Eliminación exitosa.",
      view: "Vista",
      shareClass: "Clase de acción",
      textIsNotLinked:
        "Estás a punto de eliminar permanentemente un componente genérico. Esta acción no se puede deshacer. Por favor, confirma que deseas continuar con la eliminación.",
      textIsLinkedFirstPart:
        "Estás a punto de eliminar permanentemente un componente genérico. Esta acción no se puede deshacer. Ten en cuenta que este componente está vinculado con el mismo componente en las siguientes ubicaciones: ",
      textIsLinkedSecondPart:
        "Por favor, confirma que deseas continuar con la eliminación y decide si deseas eliminar solo el componente actual o si deseas eliminar este componente y todos los componentes vinculados.",
      title: (ctx) => `Eliminación permanente de ${ctx.named("componentId")}`,
    },
    deleteUser: {
      button: "Eliminar",
      dialog: {
        confirm: "Eliminar usuario",
        text: "¿Estás seguro de que deseas eliminar permanentemente a este usuario?",
        title: "Eliminar usuario",
      },
      notify: {
        errorText: "La eliminación del usuario falló.",
        successText: "El usuario ha sido eliminado.",
      },
    },
    downloadLastFactsheet: {
      downloadLastFactsheet: "Descargar la última factsheet",
      downloadingLastFactsheet: "Descargando...",
      needLogin: {
        text: "Para poder descargar este documento, debes estar autenticado.",
        title: "Debes estar autenticado",
      },
    },
    manualVerifyEmail: {
      forceVerification: "Forzar verificación de correo electrónico",
      verified: "Correo electrónico verificado",
      notify: {
        errorText: "La verificación forzada del correo electrónico falló.",
        successText: "El correo electrónico del usuario ha sido verificado manualmente.",
      },
    },
    riskProfile: {
      higherRisk: "Mayor riesgo",
      lowerRisk: "Menor riesgo",
    },
  },
  graphs: {
    logScale: "Escala logarítmica",
    notEnoughData:
      "No hay suficientes datos para trazar este gráfico, por favor, selecciona un rango de fechas más largo.",
    needMoreData:
      "Para calcular esta métrica, es necesaria una cierta cantidad de datos al principio. Amplía el marco de tiempo para obtener acceso a esta métrica.",
  },
  holdingDataAdjustments: {
    categorise: {
      addCategory: {
        button: "Añadir categoría",
        prompt: {
          category: "Categoría",
          product: "Producto",
          property: "Propiedad",
          title: "Añadir una categoría",
          value: "Valor",
          valueAlreadyHasCategory: "Este valor ya está asignado a una categoría.",
        },
      },
      exportCategories: {
        button: "Exportar categorías como CSV",
        buttonTooltip: "Descarga los mapeos de categorías mostrados como un archivo CSV.",
      },
      importCategories: {
        button: "Importar categorías desde CSV",
        buttonTooltip:
          "Importar un archivo CSV para actualizar las asignaciones de categorías en masa.",
        importPrompt: {
          buttonCancel: "Cancelar",
          buttonImport: "Importar",
          text: "Sube un archivo CSV formateado correctamente para actualizar tus asignaciones. Recomendamos exportar la asignación actual primero para verificar la estructura de las columnas. Puedes subir un archivo parcial que contenga solo filas nuevas o modificadas; los datos no mencionados no se cambiarán.",
          title: "Importar categorías a través de CSV",
        },
        importErrorsPrompt: {
          close: "Cerrar",
          selectErrorType: "Seleccionar tipo de error:",
          title: "Errores de validación de CSV",
          columns: {
            firstRow: "Primera fila",
            productName: "Nombre del producto",
            property: "Propiedad",
            rowIndex: "Índice de fila",
            value: "Valor",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Faltan las siguientes columnas requeridas:",
            notExpectedColumns: "Se encontraron las siguientes columnas inesperadas:",
            title: "Discrepancia de columna",
            text: 'Asegúrate de que el encabezado del CSV contenga las siguientes columnas: "product_name, property, value, category".',
          },
          nonExistentProductName: {
            title: "Nombre de producto desconocido",
            text: "Asegúrate de que todos los nombres de productos existan.",
          },
          invalidPropertyForProductName: {
            title: "Propiedad inválida para el producto",
            text: 'Algunas propiedades no están disponibles para los productos seleccionados. Elimínalas o revísalas en la pestaña "Datos de tenencia" bajo la sección "Productos" en el panel de administración.',
          },
          duplicatedCategory: {
            title: "Categoría duplicada para un valor",
            text: "Elimina las entradas de categoría duplicadas para el mismo valor.",
          },
          papaparseMissingQuotes: {
            title: "Comillas sin cerrar",
            text: "El análisis del CSV falló porque una cadena entre comillas no se cerró correctamente. Por favor, revisa si faltan comillas de cierre en tus datos.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitador indetectable",
            text: "El análisis del CSV falló. No se detectó ningún delimitador común. Asegúrate de que tu archivo utilice consistentemente un solo delimitador, típicamente una coma o un punto y coma.",
          },
          papaparseTooFewFields: {
            title: "Muy pocos campos",
            text: "El análisis del CSV falló. Algunas filas tienen menos de los 4 campos requeridos. Por favor, verifica la estructura de tu archivo.",
          },
          papaparseTooManyFields: {
            title: "Demasiados campos",
            text: "El análisis del CSV falló. Algunas filas tienen más de los 4 campos esperados. Por favor, verifica la estructura de tu archivo.",
          },
        },
      },
      saveCategories: {
        button: "Guardar todos los cambios",
        saveSuccess: "Categorías de datos de tenencia guardadas exitosamente.",
        updateWarningPrompt: {
          title: "Impacto de guardar los cambios",
          text: "Estás a punto de guardar la categorización después de modificar una o más filas al eliminar o actualizar su categoría. Si las categorías afectadas tienen traducciones guardadas, esas traducciones pueden ser eliminadas, a menos que la categoría aún exista para el mismo producto a través de otro valor. Además, si estas categorías se utilizaron para anular constituyentes de tenencia, esas anulaciones también se eliminarán, a menos que la categoría aún exista para el mismo producto a través de otro valor.",
        },
      },
    },
    translate: {
      exportTranslations: {
        button: "Exportar traducciones como CSV",
        buttonTooltip: "Descarga los mapeos de traducciones mostrados como un archivo CSV.",
      },
      importTranslations: {
        button: "Importar traducciones desde CSV",
        buttonTooltip:
          "Importar un archivo CSV para actualizar las asignaciones de traducciones en masa.",
        importPrompt: {
          buttonCancel: "Cancelar",
          buttonImport: "Importar",
          text: "Sube un archivo CSV formateado correctamente para actualizar tus asignaciones. Recomendamos exportar la asignación actual primero para verificar la estructura de las columnas. Puedes subir un archivo parcial que contenga solo filas nuevas o modificadas; los datos no mencionados no se cambiarán.",
          title: "Importar traducciones a través de CSV",
        },
        importErrorsPrompt: {
          close: "Cerrar",
          selectErrorType: "Seleccionar tipo de error:",
          title: "Errores de validación de CSV",
          columns: {
            firstRow: "Primera fila",
            language: "Idioma",
            productName: "Nombre del producto",
            property: "Propiedad",
            rowIndex: "Índice de fila",
            category: "Categoría",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Faltan las siguientes columnas requeridas:",
            notExpectedColumns: "Se encontraron las siguientes columnas inesperadas:",
            title: "Discrepancia de columna",
            text: (ctx) =>
              `Asegúrate de que el encabezado del CSV contenga las siguientes columnas: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          nonExistentProductName: {
            title: "Nombre de producto desconocido",
            text: "Asegúrate de que todos los nombres de productos existan.",
          },
          invalidPropertyForProductName: {
            title: "Propiedad inválida para el producto",
            text: 'Algunas propiedades no están disponibles para los productos seleccionados. Elimínalas o revísalas en la pestaña "Datos de tenencia" bajo la sección "Productos" en el panel de administración.',
          },
          duplicatedTranslations: {
            title: "Traducciones duplicadas para un valor",
            text: "Elimina las entradas de traducciones duplicadas para el mismo valor.",
          },
          invalidCategoryForProductNameAndProperty: {
            title: "Categoría inválida para la propiedad del producto",
            text: "La categoría seleccionada no existe para el producto de esta propiedad. Por favor, verifica las categorías permitidas para la propiedad dada.",
          },
          invalidTranslationLangForProductName: {
            title: "Idioma de traducción no disponible para el producto",
            text: "No puedes proporcionar una traducción en un idioma que el producto no está configurado para admitir. Por favor, exporta el CSV y revisa una fila para este producto para ver los idiomas disponibles.",
          },
          papaparseMissingQuotes: {
            title: "Comillas sin cerrar",
            text: "El análisis del CSV falló porque una cadena entre comillas no se cerró correctamente. Por favor, revisa si faltan comillas de cierre en tus datos.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitador indetectable",
            text: "El análisis del CSV falló. No se detectó ningún delimitador común. Asegúrate de que tu archivo utilice consistentemente un solo delimitador, típicamente una coma o un punto y coma.",
          },
          papaparseTooFewFields: {
            title: "Muy pocos campos",
            text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen menos columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
          },
          papaparseTooManyFields: {
            title: "Demasiados campos",
            text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen más columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
          },
        },
      },
      saveTranslations: {
        button: "Guardar todos los cambios",
        saveSuccess: "Traducciones de datos de tenencia guardadas exitosamente.",
      },
    },
    override: {
      exportOverrides: {
        button: "Exportar sobrescrituras como CSV",
        buttonTooltip: "Descarga los mapeos de sobrescrituras mostrados como un archivo CSV.",
      },
      importOverrides: {
        button: "Importar sobrescrituras desde CSV",
        buttonTooltip:
          "Importar un archivo CSV para actualizar las asignaciones de anulaciones en masa.",
        importPrompt: {
          buttonCancel: "Cancelar",
          buttonImport: "Importar",
          text: "Sube un archivo CSV formateado correctamente para actualizar tus asignaciones. Recomendamos exportar la asignación actual primero para verificar la estructura de las columnas. Puedes subir un archivo parcial que contenga solo filas nuevas o modificadas; los datos no mencionados no se cambiarán.",
          title: "Importar anulaciones a través de CSV",
        },
        importErrorsPrompt: {
          close: "Cerrar",
          selectErrorType: "Seleccionar tipo de error:",
          title: "Errores de validación de CSV",
          columns: {
            category: "Categoría",
            currency: "Moneda",
            firstRow: "Primera fila",
            holdingName: "Nombre de tenencia",
            isin: "ISIN",
            productName: "Nombre del producto",
            property: "Propiedad",
            rowIndex: "Índice de fila",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Faltan las siguientes columnas requeridas:",
            notExpectedColumns: "Se encontraron las siguientes columnas inesperadas:",
            title: "Discrepancia de columna",
            text: (ctx) =>
              `Asegúrate de que el encabezado del CSV contenga las siguientes columnas: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          unknownProductName: {
            title: "Nombre de producto desconocido",
            text: "Algunos nombres de productos en tu archivo no coinciden con ningún producto existente. Por favor, revisa si hay errores tipográficos o nombres inválidos.",
          },
          invalidPropertyForProductName: {
            title: "Propiedad inválida para el producto",
            text: 'Algunas propiedades no están disponibles para los productos seleccionados. Elimínalas o revísalas en la pestaña "Datos de tenencia" bajo la sección "Productos" en el panel de administración.',
          },
          unknownOverrideCategory: {
            title: "Categoría de anulación desconocida",
            text: "Uno o más valores de anulación se refieren a una categoría inexistente para el producto y la propiedad especificados. Por favor, verifica las categorías disponibles antes de importar.",
          },
          invalidConstituent: {
            title: "Clave de constituyente inválida",
            text: "Algunas filas se refieren a constituyentes (Nombre del producto, Nombre de la tenencia, ISIN, Moneda) que no existen. Por favor, elimina o corrige estas entradas.",
          },
          duplicateConstituent: {
            title: "Anulaciones duplicadas",
            text: "Se encontraron múltiples entradas de anulación para el mismo constituyente (Nombre del producto, Nombre de la tenencia, ISIN, Moneda). Por favor, mantén solo una entrada por constituyente.",
          },
          papaparseMissingQuotes: {
            title: "Comillas sin cerrar",
            text: "El análisis del CSV falló porque una cadena entre comillas no se cerró correctamente. Por favor, revisa si faltan comillas de cierre en tus datos.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitador indetectable",
            text: "El análisis del CSV falló. No se detectó ningún delimitador común. Asegúrate de que tu archivo utilice consistentemente un solo delimitador, típicamente una coma o un punto y coma.",
          },
          papaparseTooFewFields: {
            title: "Muy pocos campos",
            text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen menos columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
          },
          papaparseTooManyFields: {
            title: "Demasiados campos",
            text: "El análisis del CSV falló. Cada fila debe tener el mismo número de columnas que los encabezados. Actualmente, algunas filas tienen más columnas de las esperadas. Por favor, revisa la estructura de tu archivo.",
          },
        },
      },
      saveOverrides: {
        button: "Guardar todos los cambios",
        saveSuccess: "Anulaciones de datos de tenencia guardadas exitosamente.",
      },
    },
  },
  images: {
    uploadImage: {
      darkening: "Oscurecimiento",
      file: "Archivo",
      noFile: "Sin archivo",
      noImage: "Sin imagen",
      promptTitle: "Subir nueva imagen",
      selectFile: "Seleccionar archivo",
      selectNewImage: "Seleccionar nueva imagen",
      submit: "Enviar",
      submitting: "Enviando...",
      errorTitleTooLarge: "Imagen demasiado grande",
      errorMessageTooLarge:
        "La imagen es demasiado grande. Por favor, selecciona otra imagen con un tamaño menor a 30 MB.",
      warningTitleVeryLarge: "Imagen muy grande",
      warningMessageVeryLarge:
        "La imagen es muy grande. Hará que las páginas que muestren esta imagen tarden más en cargarse. Para un mejor rendimiento, se aconseja usar imágenes de menos de 10 MB.",
    },
  },
  linkPrompt: {
    componentLinkedTo: "Este componente está vinculado a:",
    currentView: "Vista actual",
    currentShareClass: "Clase de acción actual",
    linkThroughViewsTooltip:
      'Habilitar esta función crea una conexión sincronizada entre componentes a través de múltiples vistas. Por ejemplo, vincular las vistas de "Factsheet" y "Resumen" asegura que cualquier edición a un componente compartido se actualice en ambas vistas simultáneamente. Importante: El contenido del componente vinculado se duplica desde la vista de origen que estás editando actualmente. Si inicias la vinculación mientras editas el componente de "descripción" de la vista de "Factsheet", el componente de "descripción" en "Factsheet" se copia al "Resumen" y, por lo tanto, sobrescribirá el componente de "descripción" del "Resumen".',
    linkThroughShareClassesTooltip:
      "Habilitar esta función crea una conexión sincronizada entre componentes a través de múltiples clases de acciones. Por ejemplo, vincular 'Mi Clase de Acción A' y 'Mi Clase de Acción B' asegura que cualquier edición a un componente compartido se actualice en ambas clases de acciones simultáneamente. Importante: El contenido del componente vinculado se duplica desde la vista de origen que estás editando actualmente. Si inicias la vinculación mientras editas el componente de \"descripción\" de la vista 'Mi Clase de Acción A', el componente de \"descripción\" en 'Mi Clase de Acción A' se copia a 'Mi Clase de Acción B' y, por lo tanto, sobrescribirá el componente de \"descripción\" de 'Mi Clase de Acción B'.",
    linkThroughShareClassesForbiddenCrossProductTooltip:
      "Este componente muestra datos de todas las clases de acciones, por lo que siempre está vinculado a todas las clases de acciones del producto. Por este motivo, no se pueden desvincular clases de acciones individualmente; solo se pueden eliminar los enlaces a otras vistas.",
    linkedWithViews: "Vinculado con las siguientes vistas",
    linkedWithShareClasses: "Vinculado con las siguientes clases de acciones",
    view: "Vista",
    shareClass: "Clase de acción",
    title: (ctx) => `Editar vinculación de ${ctx.named("componentId")}`,
    unlink: "Desvincular",
    unlinking: "Desvinculando ...",
    unsavedChangesAlert: "Tienes cambios sin guardar. Si te vas sin guardar, se perderán.",
    confirmSaveDialog: {
      computingNewLinks: "Calculando nuevas vinculaciones...",
      onceLinked:
        "Una vez vinculado, cuando se aplique un cambio a un componente en cualquiera de esas ubicaciones (incluida la actual), todos los demás componentes vinculados se actualizarán de la misma manera. Por favor, confirma que deseas continuar con el guardado.",
      overwrittenExistingComponent: "Sobrescribiendo un componente con el mismo ID",
      overwrittenExistingComponentTooltip: (ctx) =>
        `Advertencia: Ya existe un componente con el ID '${ctx.named("componentId")}' en esta ubicación, por lo que será sobrescrito por este componente si lo vinculas.`,
      title: "Confirmar guardado de nuevas vinculaciones",
      youAreAboutToLink:
        "Estás a punto de vincular el componente actual con los componentes en las siguientes ubicaciones:",
    },
    overviewStyle: {
      title: "Editar los enlaces en el estilo del resumen",
      saveSuccess: "La actualización de los enlaces de estilo se realizó correctamente.",
    },
    reportFooter: {
      title: "Editar enlaces en el pie de página del informe",
      saveSuccess: "La actualización de los enlaces del pie de página se realizó con éxito.",
    },
    reportHeader: {
      title: "Editar enlaces en el encabezado del informe",
      saveSuccess: "La actualización de los enlaces del encabezado se realizó con éxito.",
    },
    reportStyle: {
      title: "Editar enlaces en el estilo del informe",
      saveSuccess: "La actualización de los enlaces de estilo se realizó con éxito.",
    },
    notify: {
      linkSaveSuccess: (ctx) =>
        `La actualización de la vinculación de '${ctx.named("componentId")}' se realizó con éxito.`,
    },
    multiselect: {
      placeholderShareClasses: "Seleccionar clases de acciones para vincular",
      placeholderViews: "Seleccionar vistas para vincular",
      selectLabel: "Pulsa enter para seleccionar",
      deselectLabel: "Pulsa enter para eliminar",
      selectedLabel: "Seleccionados",
    },
    overviewHeader: {
      title: "Editar vinculación del encabezado del resumen",
      saveSuccess: "La actualización de la vinculación del encabezado se realizó con éxito.",
    },
  },
  pricesManagement: {
    addData: "Añadir datos",
    autoDataUpdate: "Tus datos se actualizan automáticamente.",
    date: "Fecha",
    datePlaceholder: "AAAA-MM-DD",
    dateValidationError: "No puedes añadir una fecha que ya tiene un valor.",
    exportCsvButton: "Exportar como CSV",
    importCsvButton: "Importar desde CSV",
    launchPriceUpdateButton: "Iniciar actualización",
    launchPriceUpdateTooltip:
      "Al hacer clic en este botón, se fuerza una actualización obteniendo los datos más recientes de la fuente normalmente usada para la actualización automática diaria (si estos datos se actualizan automáticamente). Los datos pueden tardar unos minutos en obtenerse y actualizarse.",
    launchPriceUpdateRunningTooltip: "Los precios se están obteniendo actualmente.",
    loadingData: "Cargando datos...",
    price: "Precio",
    priceAdj: "Precio (ajustado)",
    priceAdjTooltip:
      "Generalmente, los precios ajustados significan precios que se ajustan por dividendos, divisiones y otros eventos. Si no se proporciona, se asume que es el mismo que el precio.",
    priceAdjTooltipTable:
      "Generalmente, los precios ajustados significan precios que se ajustan por dividendos, divisiones y otros eventos.",
    refreshButton: "Actualizar",
    removeData: "Eliminar datos",
    benchmarks: {
      noBenchmark: "No hay índice de referencia disponible para este producto.",
    },
    dialog: {
      removeData: {
        title: "Eliminar un punto de datos",
        text: "Estás a punto de eliminar completamente un punto de datos. ¿Estás seguro?",
      },
    },
    importCsvText: {
      para1:
        "Se espera que el archivo de entrada esté en formato CSV, con dos o tres columnas y una fila de encabezado.",
      para2:
        "La primera columna debe consistir en fechas, y la segunda columna debe consistir en números (el precio en la fecha correspondiente). Una tercera columna es opcional, y si se proporciona, debe consistir en números correspondientes al precio ajustado; si no se proporciona, se asume que los precios ajustados son los mismos que los precios.",
      para3:
        "Asegúrate de que tu CSV sea válido para evitar cualquier problema al leer y analizar los datos.",
    },
    notify: {
      dateUsedMultipleTimeError:
        "Hay varios precios asociados a una misma fecha. Debes asegurarte de que cada fecha tenga un precio único asignado.",
      launchSuccessText:
        "La actualización de precios se inició correctamente. Actualiza en unos minutos para ver los resultados.",
      launchErrorText: "Error al iniciar la actualización de precios, por favor contáctanos.",
      nanFound:
        "Se encontraron algunos valores vacíos, asegúrate de que todas las filas y columnas contengan un valor.",
      numberFormatError:
        'Al menos uno de los números tiene un formato no reconocido. Lo ideal es que no uses separadores de miles y uses un punto para el separador decimal, ya que este es el formato esperado. Por ejemplo, "102.12", "1380.25", "18.952", ...',
      saveErrorText: "Error al actualizar los precios, por favor contáctanos.",
      saveSuccessText: "Los precios se actualizaron exitosamente.",
    },
    prompt: {
      addPrice: "Añadir un precio",
      importCsv: "Importar datos desde CSV",
    },
  },
  tables: {
    metricsTable: {
      na: "N/A",
      name: "Nombre",
      showLess: "Mostrar menos",
      showMore: "Mostrar más",
    },
    monthlyReturnsTable: {
      benchmark: "Índice de referencia",
      return: "Retorno",
    },
    performanceTable: {
      computedFromTo: (ctx) =>
        `Rendimiento calculado desde ${ctx.named("firstDate")} hasta ${ctx.named("lastDate")}.`,
      notAvailableData:
        "Datos no disponibles, ya sea porque no hay suficientes días para calcularlos, los datos no son significativos (por ejemplo, ratio de Sharpe negativo), o el índice de referencia no siempre está disponible durante el período seleccionado.",
    },
    holdingsTable: {
      noDataYet: "Este componente aún no tiene datos.",
      holdingFields: {
        currency: "Moneda",
        holdingName: "Nombre",
        isin: "ISIN",
        value: "Valor",
        weight: "Peso",
      },
      totalOfPortfolio: "Total de la cartera",
      holdingsCountSummary: (ctx) => `${ctx.named("shown")} de ${ctx.named("total")} tenencias`,
    },
    liquidityAnalysisTable: {
      noDataYet: "Este componente aún no tiene datos.",
      description: "Descripción",
      isin: "ISIN",
      currency: "Moneda",
      aumInLocalCurrency: (ctx) => `AUM (${ctx.named("currency")})`,
      weight: "Peso",
      lessThanOneDay: "0-1 día",
      twoToSevenDays: "2-7 días",
      eightToThirtyDays: "8-30 días",
      thirtyOneToNinetyDays: "31-90 días",
      ninetyOneToOneHundredEightyDays: "91-180 días",
      oneHundredEightyOneToThreeHundredSixtyFiveDays: "181-365 días",
      moreThanThreeHundredSixtyFiveDays: ">365 días",
      totalOfPortfolio: "Total de la cartera",
    },
  },
  thirdParty: {
    vuePhoneNumberInput: {
      countrySelectorLabel: "Código de país",
      countrySelectorError: "Selecciona un país",
      phoneNumberLabel: "Número de teléfono",
      example: "Ejemplo:",
    },
  },
  videos: {
    uploadVideo: {
      file: "Archivo",
      noFile: "Sin archivo",
      noVideo: "Sin vídeo",
      selectFile: "Seleccionar archivo",
      selectNewVideo: "Seleccionar nuevo vídeo",
      errorTitleTooLarge: "Vídeo demasiado grande",
      errorMessageTooLarge:
        "El vídeo es demasiado grande. Por favor, selecciona otro vídeo con un tamaño menor a 30 MB.",
      warningTitleVeryLarge: "Vídeo muy grande",
      warningMessageVeryLarge:
        "El vídeo es muy grande. Hará que las páginas que muestren este vídeo tarden más en cargarse. Para un mejor rendimiento, se aconseja usar vídeos de menos de 10 MB.",
    },
  },
};
